import { apiClient } from '../utils/api';
import type { User, CreateUserData, UpdateUserData, UserListResponse } from '../types/user';

export const userService = {
  // List tenant users
  async listTenantUsers(): Promise<UserListResponse> {
    const response = await apiClient.get<{data: UserListResponse}>('/auth/tenant-users');
    return response.data;
  },

  // Create tenant user
  async createTenantUser(userData: CreateUserData): Promise<User> {
    const response = await apiClient.post<{user: User}>('/auth/tenant-users', userData);
    return response.user;
  },

  // Update tenant user
  async updateTenantUser(userId: string, userData: UpdateUserData): Promise<User> {
    const response = await apiClient.put<{user: User}>(`/auth/tenant-users/${userId}`, userData);
    return response.user;
  },

  // Delete tenant user
  async deleteTenantUser(userId: string): Promise<void> {
    await apiClient.delete(`/auth/tenant-users/${userId}`);
  },

  // Get current user profile
  async getProfile(): Promise<User> {
    return apiClient.get<User>('/auth/get-profile');
  }
}; 